import axios from "axios";

export const instance = axios.create({
  baseURL: "https://hook.us1.make.com/",
});

export const postPartialSaveOnboarding = (params: any) => {
  return instance.post(`rh8jneidfocjgtalrsm13vgbrgqszmoo`, params);
};
